import { VendedorPopupComponent } from './../vendedor-popup/vendedor-popup.component';
import { CadastroWebPopupComponent } from './../cadastro-web-popup/cadastro-web-popup.component';
import { CadastroMovtoPopupComponent } from './../cadastro-movto-popup/cadastro-movto-popup.component';
import { CadastroAnacredPopupComponent } from './../cadastro-anacred-popup/cadastro-anacred-popup.component';
import { CadastroEnderecoPopupComponent } from './../cadastro-endereco-popup/cadastro-endereco-popup.component';
import { DOCUMENT } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Inject, OnDestroy, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import * as cnpj from '@fnando/cnpj';
import { Estados } from '../../../../../shared/inmemory-db/estados';
import { Cadastro } from '../../../../../shared/interfaces/cadastro';
import { CadastroGrupo } from '../../../../../shared/interfaces/cadastro-grupo';
import { Cidade } from '../../../../../shared/interfaces/cidade';
import { Endereco } from '../../../../../shared/interfaces/endereco';
import { Estado } from '../../../../../shared/interfaces/estado';
import { PageResult } from '../../../../../shared/interfaces/page-result';
import { AppConfirmService } from '../../../../../shared/services/app-confirm/app-confirm.service';
import { AppLoaderService } from '../../../../../shared/services/app-loader/app-loader.service';
import { JwtAuthService } from '../../../../../shared/services/auth/jwt-auth.service';
import { CadastroUtilsService } from '../../../../../shared/services/cadastro-utils.service';
import { Validacoes } from '../../../../../utils/validacoes';
import { CadastroGrupoService } from '../../../../../shared/services/cadastro-grupo.service';
import { CadastroService } from '../../../../../shared/services/cadastro.service';
import { CepService } from '../../../../../shared/services/cep.service';
import { CidadeService } from '../../../../../shared/services/cidade.service';
import { FatDoctoCService } from '../../../../../shared/services/fat-docto-c.service';
import { ReceitaWsService } from '../../../../../shared/services/receita-ws.service';
import { LancamentoDetailsComponent } from '../../../../../views/movimentacao/faturamento/lancamento/lancamento-details/lancamento-details.component';
import * as moment from 'moment';
import { BehaviorSubject, Observable, of, Subject, Subscription, timer } from 'rxjs';
import { catchError, debounceTime, delay, distinctUntilChanged, filter, finalize, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { CadastroGrupoTablePopupComponent } from '../../cadastro-grupo-table/cadastro-grupo-table-popup/cadastro-grupo-table-popup.component';
import { LayoutService } from '../../../../../shared/services/layout.service';
import { CadCadastroAnexoOnline } from '../../../../../shared/interfaces/cad-cadastro-anexo-online';
import * as FileSaver from 'file-saver';
import { CadastroAnexoUploadComponent } from '../cadastro-anexo-upload/cadastro-anexo-upload.component';
import { CadastroAnexoUploadListComponent } from '../cadastro-anexo-upload-list/cadastro-anexo-upload-list.component';
import { MatButton } from '@angular/material/button';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { DateAdapter } from 'angular-calendar';
import { log } from 'console';
import { CookieService } from 'ngx-cookie-service';
import { CadastroVendedorPopupComponent } from '../cadastro-vendedor-popup/cadastro-vendedor-popup.component';
import { Utils } from '../../../../../utils/utils';



export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


@Component({
  selector: 'app-cadastro-details',
  templateUrl: './cadastro-details.component.html',
  styleUrls: ['./cadastro-details.component.scss'],
  providers: [

    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    // `MomentDateAdapter` and `MAT_MOMENT_DATE_FORMATS` can be automatically provided by importing
    // `MatMomentDateModule` in your applications root module. We provide it at the component level
    // here, due to limitations of our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class CadastroDetailsComponent implements OnInit, AfterViewInit {



  layoutConf: any;
  dialogRef: MatDialogRef<any>;
  itemForm: FormGroup;
  itemFormSub: Subscription;
  itemDiretivasFatForm: FormGroup;
  cadastroId: number;
  cadastro: Cadastro;
  isSaving = false;
  isSearchingWs = false;
  isSearchingSefaz = false;
  isSearchingWs$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isSearchingCidade$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  showEditOption = true;
  filtroCidades: Cidade[] = [];
  cidades$ =  new BehaviorSubject<Cidade[]>([]);
  estados: Estado[];
  ///////////////////////
  grupos: CadastroGrupo[];
  cadMun: Cidade;
  grupo: CadastroGrupo;
  //////////////////////
  cep: any;
  isLoading = false;
  /////////////////////
  isLoadingGrupo = false;
  //////////////////////
  isLoadingCep = false;
  selectedTabIndex = 0;
  errorMsg: string;

  countDown: Subscription;

  counter = 20;
  

  contribuinteIcmsSelected: any;

  counter$: BehaviorSubject<number> = new BehaviorSubject<number>(20);

  tick = 750;

  @ViewChild('btnSaveRef') btnSaveRef: MatButton;


  maskFone = {
    mask: '(00) {*}0000-0000',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };

  maskCep = {
    mask: '00000-000',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };

  maskCpf = {
    mask: '000.000.000-00',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };

  maskCnpj = {
    mask: '00.000.000/0000-00',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };
  // máscara dinâmica usada no template para CPF/CNPJ
  currentMaskCpfCnpj: any;
  maskUpper = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toUpperCase()
  };
  maskLower = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toLowerCase()
  };

  maskEmail = {
    mask: /^\S*@?\S*$/,
    prepare: (email: any) => email.toLowerCase()
  };

  cnpjReceitaWsResult: any = null;
  cnpjReceitaResult: any = null;
  cnpjReceitaResult2: any;
  cnpjReceitaResult3: Object;
  cnpjReceitaWsResult2: string;
  cadastroSelected: Cadastro;
  dialogRefWeb: MatDialogRef<any>;
  public searching = false;

  protected _onDestroy = new Subject<void>();

  socios: Cadastro[] = [];
  socio: Cadastro;

  socioEnderecos: Endereco[];
  socioEndereco: Endereco;




  @HostListener('window:keyup.esc') onKeyUp() {
    if (this.dialog.openDialogs.length > 0) {
      console.log('@HostListener(window:keyup.esc) onKeyUp()');
      const cn = confirm('Deseja realmente sair ?')
      if (cn) {
        this.dialogRef.close();
      }
    }
  }

  @HostListener('window:beforeunload', ['$event']) unloadHandler(event: Event) {
    console.log('event:', event);
    event.returnValue = false;
  }

  constructor(
    // @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private cadastroService: CadastroService,
    private cadastroUtilsService: CadastroUtilsService,
    private cadastroGrupoService: CadastroGrupoService,
    private fatDoctoCService: FatDoctoCService,
    private cidadeService: CidadeService,
    private grupoService: CadastroGrupoService,
    private cepService: CepService,
    private receitaWsService: ReceitaWsService,
    private loader: AppLoaderService,
    private confirmService: AppConfirmService,
    private jwtAuthService: JwtAuthService,
    private cdr: ChangeDetectorRef,
    private layout: LayoutService,
    private cookieService: CookieService,
    public jwtAuth: JwtAuthService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.estados = new Estados().estados;
  }

  ngAfterViewInit() {
    setTimeout(() => this.scrollToTop());
  }

  ngOnInit() {
    this.layoutConf = this.layout.layoutConf;
    this.cadastroId = this.route.snapshot.params['id'];

    this.grupoService.getGrupoPage(1, 20).subscribe(grupos => this.grupos = grupos.content);
    
    this.buildCadastroForm(this.cadastro);
    
    // se cadastroId diferente de null diferente de undefined e maior que zero
    if(this.cadastroId != null && this.cadastroId != undefined && this.cadastroId > 0) {
      this.getCadastro();
      this.showEditOption = false;
    } else {
      this.createCadastro();
      this.showEditOption = true;
    }
    // Add class for print media check _invoice.scss
    this.document.body.classList.add('print-body-content');

    this.cadastroService.jwtAuthService.subjApiUrl$.pipe(distinctUntilChanged()).subscribe(() => {
      this.getCadastro();
    });


  

  }

  
  createCadastro() {
    this.cadastroService.create().subscribe((cadastro) => {
      this.cadastro = cadastro;
      
      this.cadastro.contribuinteIcms = 'Nao';
      this.cadastro.chkAnaliseCredito = this.cadastro.chkAnaliseCredito ?? true;
      this.cadastro.cliente = true;
      this.cadastro.pessoa = 'Fisica';
      console.log('this.cadastro: >>>>>>', this.cadastro);
      let gp = this.grupos[0];
      if (this.cookieService.get('CadastroDetailComponent.grupo')) {
        gp = JSON.parse(this.cookieService.get('CadastroDetailComponent.grupo'));
      }

      this.cadastro.cadCadastroGrupo = gp;

      this.buildCadastroForm(this.cadastro);
      //path value to contribuinteIcms to Nao
      // this.itemForm.patchValue({ contribuinteIcms: 'Nao' });

      this.cdr.markForCheck();

    });
  }

  getCadastro() {
    this.cadastroService.getCadastro(this.cadastroId).subscribe((cadastro) => {
      this.cadastro = cadastro;
      this.buildCadastroForm(this.cadastro);
      this.cdr.markForCheck();
    });
  }


  buildCadastroForm(cad?: Cadastro) {
    this.cadastroSelected = cad;
    this.cadastro = cad;
    if (this.cadastroSelected?.socioAdmEndereco?.id) {
      this.socio = this.cadastroSelected.socioAdm;
      this.socioEnderecos = [this.cadastroSelected.socioAdmEndereco];
      this.socioEndereco = this.cadastroSelected.socioAdmEndereco;
      this.getSocioEnderecos();  
    }
    this.itemForm = this.cadastroUtilsService.buildForm(this.fb, this.cadastroSelected);

    // configura máscara e validadores dinâmicos para CPF/CNPJ e obrigatoriedade de CAD-PRO
    try {
      const cpfCtrl = this.itemForm.get('cpfCnpj');
      const cadProCtrl = this.itemForm.get('inscricaoCadPro');

      // inicializa máscara com base no valor atual de `pessoa`
      const pessoaInit = this.itemForm.get('pessoa')?.value;
      this.currentMaskCpfCnpj = pessoaInit === 'Juridica' ? this.maskCnpj : this.maskCpf;

      const updateCadProRequirement = () => {
        const pessoa = this.itemForm.get('pessoa')?.value;
        const produtor = this.itemForm.get('produtor')?.value;
        if (produtor) {
          cadProCtrl?.setValidators([Validators.required]);
        } else {
          cadProCtrl?.clearValidators();
        }
        cadProCtrl?.updateValueAndValidity({ emitEvent: false });
      };

      // when pessoa changes, update mask and cpf/cnpj validators
      this.itemForm.get('pessoa')?.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((val: string) => {
        this.currentMaskCpfCnpj = val === 'Juridica' ? this.maskCnpj : this.maskCpf;
        cpfCtrl?.setValidators([Validators.required, Validacoes.validaCpfCnpj]);
        cpfCtrl?.updateValueAndValidity({ emitEvent: false });
        updateCadProRequirement();
      });

      // when produtor flag changes, enforce CAD-PRO if needed
      this.itemForm.get('produtor')?.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
        updateCadProRequirement();
      });

      // run once at init
      updateCadProRequirement();
    } catch (e) {
      console.warn('Erro ao configurar validações dinâmicas do formulário', e);
    }

     /**
      * Search Sócio
      */
     this.itemForm.get('searchSocio')?.valueChanges
     .pipe(
       filter(search => !!search),
       tap(() => this.searching = true),
       takeUntil(this._onDestroy),
       debounceTime(200),
       map(search => {
         if (!this.socios) {
           return [];
         }
         return this.cadastroService.getCadastroPageSearch(1, 10, search).subscribe(socios => {
          this.socios = socios.content.filter(n => n.id !== (this.cadastro?.id??0));
         });
       }),
       delay(200),
       takeUntil(this._onDestroy)
     )
     .subscribe(result => {
       this.searching = false;
       this.selectSocio();
     },
       error => {
         this.searching = false;
         this.confirmService.confirm(
           {
             message: `A T E N Ç Ã O !  ERRO PESQUISANDO SÓCIO ADMINISTRADOR ... ${error}`,
             error: true
           });
       });


         /**
    * Search Cidades
    */
    this.itemForm.get('searchCidade')?.valueChanges
    .pipe(
      filter(search => !!search),
      tap(() => this.searching = true),
      takeUntil(this._onDestroy),
      debounceTime(200),
      map(search => {
        if (!this.cidades$.value) {
          return [];
        }
        return this.cidadeService.getCidadePageSearch(1, 50, search).pipe(tap(() => this.searching = true)).subscribe(cidades => {
          this.cidades$.next(cidades.content);
        
        });
      }),
      delay(200),
      takeUntil(this._onDestroy)
    )
    .subscribe(() => {
      this.searching = false;
      //this.selectCadMun();        
    },
      error => {
        this.searching = false;
        this.confirmService.confirm(
          {
            message: `A T E N Ç Ã O !  ERRO PESQUISANDO CIDADES ... ${error}`,
            error: true
          });
      });

    if (this.itemFormSub) {
      this.itemFormSub.unsubscribe();
    }

    this.itemDiretivasFatForm = this.fb.group({
      razaoSocial: [cad?.razaoSocial, [Validators.required]],
    });
    this.cidadeService.getCidadePage(1, 10).subscribe(cidades => {
      this.cidades$.next(cidades.content);
      this.selectCadMun();
    });

    this.cadastroService.getCadastroPage(1, 10).subscribe(socios => {
      this.socios = socios.content.filter(n => n.id !== (this.cadastro?.id??0));
      this.selectSocio();
    });

  }

  private selectSocio() {
    if (this.cadastro?.socioAdm !== undefined && this.cadastro.socioAdm !== null) {
      if (this.socios?.map(n => n.id).includes((this.cadastro.socioAdm?.id??0))) {
        const cadastro = this.socios.find(n => n.id === this.cadastro.socioAdm?.id) ?? this.cadastro.socioAdm;
        if (cadastro !== null && cadastro !== undefined) {
          this.itemForm.controls['socioAdm'].setValue(cadastro);
        }
      } else {
        this.socios.push(this.cadastro?.socioAdm??null);
      }

    }
  }

  onSelectionChangeSocio(event: any): void {
    if (event.value !== undefined) {
      this.socio = event.value;
      this.itemForm.patchValue({ socioAdm: event.value });
      this.getSocioEnderecos();
    }
  }


  private getSocioEnderecos() {
    this.cadastroService.getPageEndereco(1, 10, "NENHUM", "ASC", this.socio?.id?.toString()).subscribe(enderecos => { this.socioEnderecos = enderecos.content; });
  }

  private selectCadMun() {
    if (this.cadastro !== null && this.cadastro?.cadMun !== undefined && this.cadastro?.cadMun !== null) {
      if (this.cidades$.value.map(n => n.id).includes(this.cadastro?.cadMun?.id)) {
        const cadMun = this.cidades$.value.find(n => n?.id === this.cadastro?.cadMun.id) ?? this.cadastro?.cadMun;
        if (cadMun !== null && cadMun !== undefined) {
          this.itemForm.controls['cadMun'].setValue(cadMun);
        }
      } else {
        this.cidades$.value.push(this.cadastro?.cadMun);
        this.cidades$.next(this.cidades$.value);
      }
    }
  }

  submit() {
    console.log(this.itemForm.value.endereco);
    this.itemForm.value.inscricaoFederal = this.itemForm.value.cpfCnpj;
    this.itemForm.value.cpf = this.itemForm.value.cpfCnpj;
    this.itemForm.value.rg = this.itemForm.value.rgInscricao;
    this.itemForm.value.inscricaoEstadual = this.itemForm.value.rgInscricao;

    if (this.itemForm.invalid) {
      // this.snack.open('CAMPOS OBRIGATÓRIOS NÃO PREENCHIDOS, VERIFIQUE!', 'ERRO', { duration: 6500 });
      this.confirmService.confirm(
        {
          message: `CAMPOS OBRIGATÓRIOS NÃO PREENCHIDOS, VERIFIQUE! ...`,
          error: true
        });
      return;
    }
    this.isSaving = true;
    this.cadastroService.saveOrUpdate(this.itemForm.value)
      .subscribe((cadastro) => {
        this.isSaving = false;
        this.showEditOption = false;

        this.cadastro = cadastro;
        this.buildCadastroForm(this.cadastro);
        this.cdr.markForCheck();
        if (cadastro) {
          this.router.navigateByUrl('/cadastro_detail/' + cadastro.id);
        }

      },  error => {
        this.isSaving = false;
        this.confirmService.confirm(
          {
            message: `A T E N Ç Ã O !  NÃO FOI POSSÍVEL SALVAR CADASTRO: ${error}`,
            error: true
          });
      });
  }

  save(): BehaviorSubject<Cadastro> {
    console.log(this.itemForm.value.endereco);
    this.itemForm.value.inscricaoFederal = this.itemForm.value.cpfCnpj;
    this.itemForm.value.cpf = this.itemForm.value.cpfCnpj;
    this.itemForm.value.rg = this.itemForm.value.rgInscricao;
    this.itemForm.value.inscricaoEstadual = this.itemForm.value.rgInscricao;
    if (this.itemForm.invalid) {
      this.confirmService.confirm(
        {
          message: `CAMPOS OBRIGATÓRIOS (*) NÃO PREENCHIDOS, VERIFIQUE! ...`,
          error: true
        });
      throw new Error('FORMULÁRIO INVÁLIDO');
    }
  
    // const item = this.jwtAuth.itemRemoto?? this.jwtAuth.item;

    const result = new BehaviorSubject<Cadastro>(null as any);
    this.cadastroService.saveOrUpdate(this.itemForm.value).subscribe(
      val => {
        console.log(val);
        // this.snack.open(`SALVO COM SUCESSO!`, 'OK', { duration: 5500 });
          this.confirmService.confirm({
            title: 'S U C E S S O !',
            icon: 'check_circle',
            message: 'OK, CADASTRO SALVO COM SUCESSO !', error: false
          });
        result.next(val);
        this.cadastro = val;
        this.buildCadastroForm(this.cadastro);
        this.cdr.markForCheck();
      },
      err => {
        result.error(err);
        // this.snack.open(`ERRO:${err.error.status}!`, 'ERRO', { duration: 5500 });
        this.confirmService.confirm({
          title: `A T E N Ç Ã O !  NÃO FOI POSSÍVEL SALVAR CADASTRO, VERIFIQUE !`,
          icon: 'error',
          message:JSON.stringify(err), error: true
        })
      });
    return result;
  }



    

  onFocus() {
    this.itemForm.get('cadMun')?.valueChanges
      .pipe(
        debounceTime(500),
        tap(() => this.isLoading = true),
        switchMap(value => ((typeof (value) === 'string') ?
          this.cidadeService.getCidadePageSearch(1, 10, value) : new Observable<PageResult<Cidade>>())
          .pipe(
            finalize(() => this.isLoading = false),
          )
        )
      )
      .subscribe(cidades => this.cidades$.next(cidades.content));
  }

  private scrollToTop() {
    const element = this.layoutConf?.topbarFixed
      ? this.document.querySelector('#rightside-content-hold')
      : this.document.querySelector('#main-content-wrap');

    if (element) {
      (element as HTMLElement).scrollTop = 0;
    }
  }

  onSelectionChange(event: any): void {
    this.cadMun = event.value;
    this.itemForm.patchValue({ uf: this.cadMun?.uf ?? '' });
  }

  displayFn(cidade: Cidade) {
    if (cidade) {
      return `${cidade.municipio.trim()} - ${cidade.uf.trim()}`;
    }
  }

  onFocusGrupo() {
    this.itemForm.get('cadCadastroGrupo')?.valueChanges
      .pipe(
        debounceTime(500),
        tap(() => this.isLoadingGrupo = true),
        switchMap(value => ((typeof (value) === 'string') ?
          (value !== undefined && value !== '' ? this.grupoService.getGrupoPageSearch(1, 10, value) :
            this.grupoService.getGrupoPage(1, 10)) : new Observable<PageResult<CadastroGrupo>>())
          .pipe(
            finalize(() => this.isLoadingGrupo = false),
          )
        )
      )
      .subscribe(grupos => this.grupos = grupos.content);
  }
  onSelectionChangeGrupo(event: any): void {
    //save value to cookie
    if (event.value !== undefined) {
      console.log(JSON.stringify(event.value));
      this.cookieService.set('CadastroDetailComponent.grupo', JSON.stringify(event.value));
    }
  }

  displayFnGrupo(grupo: CadastroGrupo) {
    if (grupo) {
      return `${grupo.id} - ${grupo.descricao.trim()}`;
    }
  }

  consultaCep(cep: string, ignoreEnd = false) {
    console.log('cep digitado: ' + cep);
    cep = cep.replace(/\D/g, '');
    if (cep != null && cep !== '') {
      this.cepService.consulta(cep).subscribe(dados => this.populaEndereco(dados, ignoreEnd));
    }
  }

  populaEndereco(dados: any, ignoreEnd = false) {
    console.log(dados);
    this.cidadeService.getCidadeIbge(dados.ibge).pipe(
      tap(() => this.isLoadingGrupo = true), catchError(_err => {
        console.log(_err);
        this.isLoadingCep = false;
        return of(null);
      })
    ).subscribe(c => {
      this.cadMun = c;
      if (this.cadMun) {
        this.cidades$.value.push(c);
        this.cidades$.next(this.cidades$.value);
      }
      if (ignoreEnd) {
        this.itemForm.patchValue({
          cadMun: this.cadMun,
          uf: this.cadMun.uf
        });

      } else {
        this.itemForm.patchValue({
          endereco: dados.logradouro,
          bairro: dados.bairro,
          cadMun: this?.cadMun,
          uf: this?.cadMun?.uf
        });
      }
      this.isLoadingGrupo = false
    });
  }

  cnpjIsValid(cnpjValue: string) {
    return cnpj.isValid(cnpjValue);
  }

  cadastroValid(): boolean {
    if (!this.itemForm) {
      return false;
    }
    const nome = this.itemForm.get('nomeFantasia')?.value;
    const razao = this.itemForm.get('razaoSocial')?.value;
    if (!nome || !razao) {
      return false;
    }
    const pessoa = this.itemForm.get('pessoa')?.value;
    const cpfcnpj = (this.itemForm.get('cpfCnpj')?.value || '').toString().replace(/\D/g, '');
    const rg = (this.itemForm.get('rgInscricao')?.value || '').toString().trim();
    const cadpro = (this.itemForm.get('inscricaoCadPro')?.value || '').toString().trim();
    let idOk = false;
    if (pessoa === 'Juridica') {
      idOk = !!cpfcnpj && cnpj.isValid(cpfcnpj);
    } else {
      idOk = !!cpfcnpj && cpfcnpj.length > 0;
    }
    return !!idOk || !!rg || !!cadpro;
  }

  consultaCNPJ(cnpjValue: string) {
    console.log('cnpj digitado: ' + cnpjValue);
    this.isSearchingWs$.subscribe(val => console.log(val));
    this.countDown?.unsubscribe();
    this.isSearchingWs = true;
    this.isSearchingWs$.next(true);
    if (this.counter > 0 && this.counter < 20) {
      this.isSearchingWs = false;
      this.isSearchingWs$.next(false);
      return;
    }
    // this.loader.open();
    this.counter = 19;
    this.countDown = timer(0, this.tick)
      .subscribe(() => {
        this.counter$.next(this.counter);
        if (this.counter <= 0) {
          this.counter = 20;
          this.isSearchingWs = false;
          this.isSearchingWs$.next(false);
        } else if (this.counter < 20) {
          --this.counter;
        }
      });

    this.receitaWsService.consulta(cnpjValue)
      .subscribe(dados => {
        this.snack.open('Sucesso ao pesquisa o CNPJ!', 'OK', { duration: 5500 });
        this.cnpjReceitaWsResult = dados;
        this.cnpjReceitaWsResult2 = dados.status + ' - ' + JSON.stringify(dados.nome) + ' - ' + JSON.stringify((dados.atividade_principal));
        this.populaDadosCnpj(dados);
        // this.loader.close();
      }, (err: HttpErrorResponse) => {
        console.log(err);

        this.loader.close();
        this.snack.open('Erro ao pesquisa o CNPJ!', 'ERRO', { duration: 5500 });
      });

  }

  selecionaUF() {
    const ufCadastro = (
      this.itemForm?.get('uf')?.value
      || this.itemForm?.get('cadMun')?.value?.uf
      || this.cadMun?.uf
      || this.cadastro?.cadMun?.uf
      || this.cadastro?.uf
      || this.jwtAuthService.filial$?.value?.cadMun?.uf
      || 'PR'
    )?.toString().trim();

    this.confirmService.confirm({
      title: 'Selecionar UF',
      message: 'UF:',
      options: this.estados.map(value => value.uf),
      defaultOption: ufCadastro
    })
      .subscribe(val => {
        console.log(val);
        if (val) {
          this.itemForm.patchValue({ uf: val === true ? 'PR' : val });
          this.consultaCNPJCert(this.itemForm.controls['cpfCnpj'].value)
        }
      })
  }

       

  consultaCNPJCert(cnpjValue: string) {
    this.isSearchingSefaz = true;
    this.cnpjReceitaResult2 = null;
    this.cnpjReceitaResult = null;

    // if (this.itemForm.value.uf === null ) {
    //   return;
    // }
    this.loader.open();
    this.cadastroService.getCadastroJuridicaCert(cnpjValue, this.itemForm.value.uf).subscribe(res => {
      this.loader.close();
      const dadosSefaz = res?.dados;

      if (!dadosSefaz) {
        this.isSearchingSefaz = false;
        this.cnpjReceitaResult2 = 'Retorno da SEFAZ vazio.';
        this.cnpjReceitaResult = res;
        this.cdr.markForCheck();
        this.snack.open('Não foi possível ler os dados retornados pela SEFAZ.', 'OK', { duration: 5500 });
        return;
      }

      // se SEFAZ retornar que não encontrou contribuinte (ex.: statusResposta 259)
      if (dadosSefaz.statusResposta === '259' || dadosSefaz.statusResposta === 259) {
        this.cnpjReceitaResult2 = dadosSefaz.motivo;
        this.cnpjReceitaResult = res;
        this.itemForm.patchValue({ contribuinteIcms: 'Nao' });
        this.isSearchingSefaz = false;
        this.cdr.markForCheck();
        this.snack.open(dadosSefaz.motivo || 'Não foi encontrado como contribuinte de ICMS!', 'OK', { duration: 5500 });
        return;
      }

      // this.snack.open('Sucesso ao pesquisa o CNPJ!', 'OK', { duration: 5500 });
      this.cnpjReceitaResult2 = dadosSefaz.motivo;
      this.cnpjReceitaResult = res;

      const motivoNormalized = (dadosSefaz?.motivo || '').toString().toLowerCase();
      const consultaIeIndisponivel = motivoNormalized.includes('solicitante') && motivoNormalized.includes('nao habilitado');
      if (consultaIeIndisponivel) {
        this.cnpjReceitaResult2 = 'Consulta de IE indisponível para esta UF com o certificado atual. Preencha a Inscrição Estadual manualmente.';
        this.isSearchingSefaz = false;
        this.cdr.markForCheck();
        this.snack.open(this.cnpjReceitaResult2, 'OK', { duration: 6500 });
        return;
      }

      const situacoes = Array.isArray(dadosSefaz.situacaoCadastral) ? dadosSefaz.situacaoCadastral.filter((s: any) => !!s) : [];
      if (situacoes.length > 1) {
        const options = situacoes.map((value: any) => value.inscricaoEstadual || 'SEM IE');
        this.confirmService.confirm({
          title: 'Incrições encontradas',
          message: 'Selecione uma Inscrição:', options
        })
          .subscribe(val => {
            console.log(val);
            let inscricaoEstadual;
            if (val) {
              inscricaoEstadual = situacoes.filter((insc: any) => (insc?.inscricaoEstadual || 'SEM IE') === val)[0];
              console.log('MAIS DE  1 , SELECIONADA INSC:');
              console.log(inscricaoEstadual);
            } else {
              inscricaoEstadual = situacoes.map((insc: any) => insc)[0];
              console.log('MAIS DE  1 , Ñ SELECIONADA INSC:');
              console.log(inscricaoEstadual);
            }
            if (inscricaoEstadual?.inscricaoEstadual) {
              this.cnpjReceitaResult2 = this.cnpjReceitaResult2 + ' - :' + inscricaoEstadual.inscricaoEstadual;
            }
            this.populaDadosCnpjReceita(inscricaoEstadual, dadosSefaz);
            this.isSearchingSefaz = false;
            this.cdr.markForCheck();

          })
      } else if (situacoes.length === 1) {
        const inscricaoEstadual = situacoes.map((insc: any) => insc)[0];
        if (inscricaoEstadual?.inscricaoEstadual) {
          this.cnpjReceitaResult2 = this.cnpjReceitaResult2 + ' - INCRICAO SELECIONADA:' + inscricaoEstadual.inscricaoEstadual;
        }
        console.log('APENAS 1 INSC:');
        console.log(inscricaoEstadual);
        this.populaDadosCnpjReceita(inscricaoEstadual, dadosSefaz);
        this.isSearchingSefaz = false;
        this.cdr.markForCheck();
      } else {
        this.cnpjReceitaResult2 = 'SEFAZ não retornou Inscrição Estadual para este cadastro. Preencha manualmente, se necessário.';
        this.isSearchingSefaz = false;
        this.cdr.markForCheck();
        this.snack.open(this.cnpjReceitaResult2, 'OK', { duration: 6000 });
        return;
      }

      console.log(res);
    }, (err: HttpErrorResponse) => {
      this.loader.close();
      console.log(err)
      this.confirmService.confirm({
        title: 'Erro ao pesquisa o CNPJ!',
        message: 'DETALHES:' + err.error.status, error: true
      });
      this.isSearchingSefaz = false;
      this.cdr.markForCheck();
      this.snack.open('Erro ao pesquisa o CNPJ!', 'ERRO', { duration: 5500 });

    });
  }

  private isContribuinteIcmsFromSefaz(value: any, inscricaoEstadual: string): 'Sim' | 'Nao' {
    if ((inscricaoEstadual || '').toString().trim() !== '') {
      // Regra de negócio: havendo IE retornada pela SEFAZ, contribuinte ICMS é Sim.
      return 'Sim';
    }

    const normalized = (value ?? '').toString().trim().toUpperCase();
    if (normalized === 'SIM' || normalized === 'S' || normalized === 'TRUE' || normalized === '1') {
      return 'Sim';
    }
    if (normalized === 'NAO' || normalized === 'NÃO' || normalized === 'N' || normalized === 'FALSE' || normalized === '0') {
      return 'Nao';
    }
    return inscricaoEstadual ? 'Sim' : 'Nao';
  }

  populaDadosCnpjReceita(dados: any, dadosSefaz: any = null) {
    const razaoSocial = dados?.razaoSocial || dados?.nome || dadosSefaz?.razaoSocial || dadosSefaz?.nome || '';
    const inscricaoEstadual = dados?.inscricaoEstadual || dadosSefaz?.inscricaoEstadual || '';
    const uf = dados?.uf || dadosSefaz?.uf || '';
    const endereco = dados?.endereco || dadosSefaz?.endereco || {};
    const dataInicio = dados?.dataInicioAtividade || dadosSefaz?.dataInicioAtividade;
    const contribuinteIcms = this.isContribuinteIcmsFromSefaz(dados?.contribuinteIcms ?? dadosSefaz?.contribuinteIcms, inscricaoEstadual);

    // Sem IE retornada, não abrir popup de confirmação de preenchimento.
    if ((inscricaoEstadual || '').toString().trim() === '') {
      return;
    }

    this.confirmService.confirm({ message: `ENCONTRADO:  ${razaoSocial || 'Cadastro SEFAZ'}, deseja preencher o formulário com os dados encontrado?` })
      .subscribe(res => {
        if (res) {
          let dataInicioIso: string | null = null;
          if (dataInicio) {
            const text = dataInicio.toString().trim();
            const onlyDate = text.includes('T') ? text.split('T')[0] : text;
            const ddmmyyyy = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(onlyDate);
            const yyyymmdd = /^(\d{4})-(\d{2})-(\d{2})$/.exec(onlyDate);
            const yyyymmddSlash = /^(\d{4})\/(\d{2})\/(\d{2})$/.exec(onlyDate);

            if (ddmmyyyy) {
              dataInicioIso = `${ddmmyyyy[3]}-${ddmmyyyy[2]}-${ddmmyyyy[1]}`;
            } else if (yyyymmdd) {
              dataInicioIso = `${yyyymmdd[1]}-${yyyymmdd[2]}-${yyyymmdd[3]}`;
            } else if (yyyymmddSlash) {
              dataInicioIso = `${yyyymmddSlash[1]}-${yyyymmddSlash[2]}-${yyyymmddSlash[3]}`;
            }
          }
          const razaoAjustada = razaoSocial.length > 60 ? Utils.abreviar(razaoSocial, 60) : razaoSocial;

          this.itemForm.patchValue({
            rgInscricao: inscricaoEstadual || this.itemForm.get('rgInscricao')?.value || 'ISENTO',
            contribuinteIcms,
            razaoSocial: razaoAjustada || this.itemForm.get('razaoSocial')?.value,
            uf: uf || this.itemForm.get('uf')?.value,
            cep: endereco?.cep || this.itemForm.get('cep')?.value,
            endereco: endereco?.logradouro || this.itemForm.get('endereco')?.value,
            numero: endereco?.numero || this.itemForm.get('numero')?.value,
            complemento: endereco?.complemento || this.itemForm.get('complemento')?.value,
            bairro: endereco?.bairro || this.itemForm.get('bairro')?.value,
            dataNasc: dataInicioIso || this.itemForm.get('dataNasc')?.value,
          });
          this.cdr.markForCheck();

          const cepDigits = (endereco?.cep || '').toString().replace(/\D/g, '');
          if (cepDigits.length === 8) {
            this.consultaCep(cepDigits, true);
          }
        }
      });
  }

  populaDadosCnpj(dados: any) {
    console.log(dados);
    console.log(dados.abertura);
    let telefone1 = dados.telefone;
    let telefone2 = dados.telefone;
    const telefones = dados.telefone.split('/');
    if (telefones.length > 1) {
      telefone1 = telefones[0];
      telefone2 = telefones[1];
    }

    

    this.confirmService.confirm({ message: `ENCONTRADO:  ${dados.nome}, deseja preencher o formulário com os dados encontrado?` })
      .subscribe(res => {
        if (res) {
          const currentRazaoRaw = this.itemForm.get('razaoSocial')?.value ?? '';
          const currentFantasiaRaw = this.itemForm.get('nomeFantasia')?.value ?? '';
          const currentRazao = currentRazaoRaw.toString().trim();
          const currentFantasia = currentFantasiaRaw.toString().trim();

          //checar dados.nome > que 60 caracteres emitir um confirm que vai abreviar  para 60 carcatateres
          if (dados.nome.length > 60) {
            this.confirmService.confirm({
              title: 'A T E N Ç Ã O !',
              message: `O nome ${dados.nome} é maior que 60 caracteres, deseja abreviar para 60 caracteres?`,
            }).subscribe(res => {
              if (res) {
                this.consultaCep(dados.cep, true);
                this.itemForm.patchValue({
                  // Razão Social sempre atualizada com o valor vindo do WS (abreviado)
                  razaoSocial: Utils.abreviar(dados.nome, 60),
                  nomeFantasia: currentFantasia || (dados.fantasia ? Utils.abreviar(dados.fantasia, 60) : Utils.abreviar(dados.nome, 60)),
                  telefone1: telefone1,
                  celular: telefone2,
                  cep: dados.cep,
                  endereco: dados.logradouro,
                  numero: dados.numero,
                  complemento: dados.complemento,
                  rgInscricao: 'ISENTO',
                  contribuinteIcms:'Nao',
                  bairro: dados.bairro,
                  dataNasc: moment(dados.abertura, "DD/MM/YYYY")
                    .toDate()
                    .toISOString()
                    .split("T")[0],
                  email: dados.email,
                  uf: dados.uf,
                });
                return;
              }
            });
          }

          this.consultaCep(dados.cep, true);
          this.itemForm.patchValue({
            // Razão Social sempre atualizada com o valor vindo do WS
            razaoSocial: dados.nome,
            nomeFantasia: currentFantasia || (dados.fantasia ? Utils.abreviar(dados.fantasia, 60) : Utils.abreviar(dados.nome, 60)),
            telefone1: telefone1,
            celular: telefone2,
            cep: dados.cep,
            endereco: dados.logradouro,
            numero: dados.numero,
            complemento: dados.complemento,
            rgInscricao: this.itemForm.get('rgInscricao')?.value ?? 'ISENTO',
            contribuinteIcms:'Nao',
            bairro: dados.bairro,
            dataNasc: moment(dados.abertura, 'DD/MM/YYYY').toDate().toISOString().split('T')[0],
            email: dados.email,
            uf: dados.uf
          });
        }
      });

  }

  addGrupo() {
    this.dialogRef = this.dialog.open(CadastroGrupoTablePopupComponent, {
      width: '800px',
      // height: '600px',
      disableClose: true,
      data: { title: 'Novo Grupo', payload: {} }
    })
    this.dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }
        this.loader.open();
        this.cadastroGrupoService.saveOrUpdate(res)
          .subscribe(data => {
            this.loader.close();
            this.snack.open('Cadastro de Grupo Salvo com sucesso!', 'OK', { duration: 5500 });
            this.grupo = data;
            this.itemForm.patchValue({ cadCadastroGrupo: data });
          }, () => {
            this.loader.close();
            this.snack.open('Erro ao savar o cadastro de Grupo!', 'ERRO', { duration: 5500 });
          })
      })
  }



  openLcto(controle: number) {
    this.loader.open();
    this.fatDoctoCService.getFatDoctoC(controle).subscribe(val => {
      this.openPopUp(val);
      this.loader.close();
    }, ee => {
      this.loader.close();
      this.confirmService.confirm({ message: `ERRO AO CARREGAR LCTO: ${ee}`, error: true })
    }, () => {
      this.loader.close();
    });
  }

  openPopUp(data: any = {}) {

    this.dialogRef = this.dialog.open(LancamentoDetailsComponent, {
      width: this.layoutConf?.isMobile ? '100vw' : '98%',
      maxWidth: '100vw',
      height: this.layoutConf?.isMobile ? '100dvh' : '90vh',
      maxHeight: '100dvh',
      panelClass: this.layoutConf?.isMobile ? ['dialog-fullscreen'] : undefined,
      disableClose: false,
      data: { payload: data, openAsModal: true }
    });


    if (this.dialogRef) {
      this.dialogRef.disableClose = true;
      // this.dialogRef.backdropClick().subscribe(_ => {
      //   if (this.dialog.openDialogs.length > 0) {
      //     const cn = confirm('Deseja realmente sair ?')
      //     if (cn) {
      //       this.dialogRef.close();
      //     }
      //   }
      // })
    }

    this.dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }
        this.loader.open();
        this.fatDoctoCService.saveOrUpdate(res)
          .subscribe(() => {
            this.loader.close();
            this.snack.open('Lançamento salvo com sucesso!', 'OK', { duration: 5500 })
          }, () => {
            this.loader.close();
            this.snack.open('Erro ao salvar o lançamento!', 'ERRO', { duration: 5500 });
          })
      })
  }


  instanceOfACidade = (p: any): p is Cidade => p.hasOwnProperty('id');


  instanceOfA(object: any): object is Endereco {

    return 'cadMun' in object && this.instanceOfACidade(object.cadMun);
  }

  openEnderecosPopUp(cad: any = {}) {
    if (this.verifyIsNotSaved(this.cadastro)) return;
    let title = "Endereços: ";
    let dialogRef: MatDialogRef<any> = this.dialog.open(CadastroEnderecoPopupComponent, {
      width: this.layoutConf?.isMobile ? '100vw' : '80%',
      maxWidth: '100vw',
      height: this.layoutConf?.isMobile ? '100dvh' : undefined,
      maxHeight: '100dvh',
      disableClose: true,
      panelClass: this.layoutConf?.isMobile ? ['dialog-fullscreen'] : undefined,
      data: { title: title + "[ " + this.cadastro?.codigo + " - " + (this.cadastro?.razaoSocial ?? '') + " ]", payload: cad }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }
        this.loader.open();
      })
  }

  openVendedoresPopUp(cad: any = {}) {
    if (this.verifyIsNotSaved(this.cadastro)) return;
    let title = "Vendedores/Representates de: ";
    let dialogRef: MatDialogRef<any> = this.dialog.open(CadastroVendedorPopupComponent, {
      width: this.layoutConf?.isMobile ? '100vw' : '80%',
      maxWidth: '100vw',
      height: this.layoutConf?.isMobile ? '100dvh' : undefined,
      maxHeight: '100dvh',
      disableClose: true,
      panelClass: this.layoutConf?.isMobile ? ['dialog-fullscreen'] : undefined,
      data: { title: title + "[ " + this.cadastro?.codigo + " - " + (this.cadastro?.razaoSocial ?? '') + " ]", payload: cad }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }
        this.loader.open();
      })
  }




  openMovtoPopUp(cad: any = {}) {
    if (this.verifyIsNotSaved(this.cadastro)) return;
    let title = "Movimentações: ";
    let dialogRef: MatDialogRef<any> = this.dialog.open(CadastroMovtoPopupComponent, {
      width: this.layoutConf?.isMobile ? '100vw' : '98%',
      maxWidth: '100vw',
      height: this.layoutConf?.isMobile ? '100dvh' : undefined,
      maxHeight: '100dvh',
      disableClose: true,
      panelClass: this.layoutConf?.isMobile ? ['dialog-fullscreen'] : undefined,
      data: { title: title + "[ " + cad.codigo + " - " + cad.razaoSocial + " ]", payload: cad }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }
        this.loader.open();
      })
  }

  openAnaliseCreditoPopUp(cad: any = {}) {
    if (this.verifyIsNotSaved(this.cadastro)) return;
    const title = "Análise de Crédito: ";
    const dialogRef: MatDialogRef<any> = this.dialog.open(CadastroAnacredPopupComponent, {
      width: this.layoutConf?.isMobile ? '100vw' : '70%',
      maxWidth: '100vw',
      height: this.layoutConf?.isMobile ? '100dvh' : undefined,
      maxHeight: '100dvh',
      disableClose: true,
      panelClass: this.layoutConf?.isMobile ? ['dialog-fullscreen'] : undefined,
      data: { title: title + "[ " + cad.codigo + " - " + cad.razaoSocial + " ]", payload: cad }
    });

    dialogRef.afterClosed().subscribe((updatedCad: Cadastro) => {
      if (!updatedCad) {
        return;
      }

      this.cadastro = {
        ...this.cadastro,
        ...updatedCad,
      };

      this.itemForm?.patchValue({
        chkAnaliseCredito: this.cadastro?.chkAnaliseCredito ?? true,
        limiteCredito: this.cadastro?.limiteCredito ?? 0,
      });

      this.cdr.markForCheck();
    });
  }

  openWebPopUp(cad: any = {}) {
    if (this.verifyIsNotSaved(this.cadastro)) return;
    let title = "Informações p/ servidor WEB: ";
    let dialogRef: MatDialogRef<any> = this.dialog.open(CadastroWebPopupComponent, {
      width: this.layoutConf?.isMobile ? '100vw' : '70%',
      maxWidth: '100vw',
      height: this.layoutConf?.isMobile ? '100dvh' : undefined,
      maxHeight: '100dvh',
      disableClose: true,
      panelClass: this.layoutConf?.isMobile ? ['dialog-fullscreen'] : undefined,
      data: { title: title + "[ " + cad.codigo + " - " + cad.razaoSocial + " ]", payload: cad }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        this.getCadastro();
        if (!res) {
          return;
        }
        this.loader.open();
      })
  }

  openAnexoUploadListPopUp(cad: any = {}) {
    if (this.verifyIsNotSaved(this.cadastro)) return;
    let title = "Anexos: ";
    let dialogRef: MatDialogRef<any> = this.dialog.open(CadastroAnexoUploadListComponent, {
      width: this.layoutConf?.isMobile ? '100vw' : '80%',
      maxWidth: '100vw',
      height: this.layoutConf?.isMobile ? '100dvh' : undefined,
      maxHeight: '100dvh',
      disableClose: true,
      panelClass: this.layoutConf?.isMobile ? ['dialog-fullscreen'] : undefined,
      data: { title: title + "[ " + cad.codigo + " - " + cad.razaoSocial + " ]", payload: cad }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }
      })
  }


  close() {
    history.back();
    // this.confirmService.confirm({ message: `Deseja realmente Sair? Poderá haver perda de dados.` })
    //   .subscribe(res => {
    //     if (res) {
    //       history.back();
    //     }
    //   });
  }

  print() {
    window.print();
  }

  public objectComparisonFunction = function (option, value): boolean {
    return option.id === value.id;
  }

  verifyIsNotSaved(data: any, showMessage = true): boolean {
    var ctrl = data.id;
    console.log(data);

    if (ctrl === undefined || ctrl === null || ctrl === 0) {
      if (showMessage) {
        this.confirmService.confirm(
          {
            message: `Por favor, salve o cadastro e tente novamente !!`,
            error: true
          }
        );
      }
      return true;
    }
    return false;
  }

  preencheNomeFantasia(){
    console.log('preencheNomeFantasia');
    if (!this.itemForm.get('nomeFantasia')?.value && (this.itemForm.get("id")?.value??0)===0) {
      this.itemForm.patchValue({ nomeFantasia: this.itemForm.get('razaoSocial')?.value });
    }
  }

  getConsultaSefazBadgeClass(): 'ok' | 'warn' | 'error' {
    if (!this.cnpjReceitaResult) {
      return 'warn';
    }

    if (this.cnpjReceitaResult?.installed === false) {
      return 'error';
    }

    const status = this.cnpjReceitaResult?.dados?.statusResposta;
    if (status === '259' || status === 259) {
      return 'error';
    }

    const hasSituacoes = Array.isArray(this.cnpjReceitaResult?.dados?.situacaoCadastral)
      && this.cnpjReceitaResult?.dados?.situacaoCadastral.length > 0;

    return hasSituacoes ? 'ok' : 'warn';
  }

  getConsultaSefazBadgeLabel(): string {
    const state = this.getConsultaSefazBadgeClass();
    if (state === 'error') {
      return 'Falha';
    }
    if (state === 'warn') {
      return 'Alerta';
    }
    return 'Válido';
  }

  getConsultaSefazBadgeIcon(): string {
    const state = this.getConsultaSefazBadgeClass();
    if (state === 'error') {
      return 'gpp_bad';
    }
    if (state === 'warn') {
      return 'warning_amber';
    }
    return 'verified';
  }

  getConsultaSefazMessage(): string {
    if (!this.cnpjReceitaResult) {
      return 'Nenhuma consulta SEFAZ executada.';
    }

    if (this.cnpjReceitaResult?.installed === false) {
      return this.cnpjReceitaResult?.status || 'Certificado não configurado.';
    }

    const motivo = this.cnpjReceitaResult?.dados?.motivo;
    const status = this.cnpjReceitaResult?.dados?.statusResposta;
    const motivoNormalized = (motivo || '').toString().toLowerCase();

    if (motivoNormalized.includes('solicitante') && motivoNormalized.includes('nao habilitado')) {
      return 'Consulta de IE indisponível para esta UF com o certificado atual. Preencha a Inscrição Estadual manualmente.';
    }

    if (status === '259' || status === 259) {
      return motivo || 'Não encontrado como contribuinte de ICMS.';
    }

    return motivo || 'Consulta SEFAZ executada com sucesso.';
  }

  getConsultaSefazMessageCompact(): string {
    const baseMessage = this.getConsultaSefazMessage();
    if (!baseMessage) {
      return 'Consulte os detalhes no resultado abaixo nesta página.';
    }

    const normalized = baseMessage.toLowerCase();
    if (normalized.includes('detalhes') && normalized.includes('abaixo')) {
      return baseMessage;
    }

    return `${baseMessage} Consulte os detalhes no resultado abaixo nesta página.`;
  }

  getConsultaWsBadgeClass(): 'ok' | 'warn' | 'error' {
    if (!this.cnpjReceitaWsResult) {
      return 'warn';
    }

    const status = (this.cnpjReceitaWsResult?.status || '').toString().toUpperCase();
    if (status === 'OK') {
      return 'ok';
    }
    if (status.includes('ERROR')) {
      return 'error';
    }
    return 'warn';
  }

  getConsultaWsBadgeLabel(): string {
    const state = this.getConsultaWsBadgeClass();
    if (state === 'error') {
      return 'Falha';
    }
    if (state === 'warn') {
      return 'Alerta';
    }
    return 'Válido';
  }

  getConsultaWsBadgeIcon(): string {
    const state = this.getConsultaWsBadgeClass();
    if (state === 'error') {
      return 'gpp_bad';
    }
    if (state === 'warn') {
      return 'warning_amber';
    }
    return 'verified';
  }

  getConsultaWsMessage(): string {
    if (!this.cnpjReceitaWsResult) {
      return 'Nenhuma consulta WS executada.';
    }
    const status = this.cnpjReceitaWsResult?.status;
    if ((status || '').toString().toUpperCase() === 'OK') {
      return 'Consulta Receita WS executada com sucesso.';
    }
    return this.cnpjReceitaWsResult?.message || this.cnpjReceitaWsResult?.status || 'Consulta Receita WS executada com pendência.';
  }

  ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();
  }



}
